import { cn } from "@/libs/utils/tailwind/cn";
import { SlotsToClasses } from "@nextui-org/react";
import { Button } from "@/components/ui/Button";
import ListOutlineIcon from "./assets/ListOutlineIcon";
import GuaranteedIcon from "./assets/GuaranteedIcon";
import PeopleIcon from "./assets/PeopleIcon";

export default function HowItWorksSection({
  className,
  classNames,
  onStartNowPress,
}: HowItWorksSectionProps) {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    onStartNowPress?.();
  };
  return (
    <section
      className={cn(classNames?.base, className)} >
      <div className={cn(classNames?.container)}>
        <h2 className="text-foreground text-center text-[28px] md:text-[56px] font-semibold tracking-tight">
          How it works
        </h2>
        <p className="mx-auto max-w-2xl text-center leading-tight text-base sm:text-lg text-default-800 mb-8 sm:mb-10 mt-3 sm:mt-7">
          Tell us what you need — we’ll match you with trusted local pros in
          seconds.
        </p>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {STEPS.map(({ title, description, icon }, key) => (
            <div
              key={key}
              className="flex sm:min-h-[315px] flex-col items-start rounded-xl bg-white p-6 sm:px-8 sm:py-10 shadow-sm"
            >
              <div className="flex items-center gap-4 sm:gap-5 mb-4">
                <div className="mr-auto sm:mb-6">{icon}</div>

                <h3 className="text-foreground text-[20px] sm:text-[28px] font-semibold leading-tight tracking-tight">
                  {title}
                </h3>
              </div>

              <p className="max-w-sm text-base sm:text-lg leading-6 text-default-800">
                {description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-9 flex justify-center">
          <Button
            radius="lg"
            className="w-full sm:w-fit h-12 bg-foreground px-7 font-semibold text-background text-lg"
            onPress={scrollToTop}>
            Start now
          </Button>
        </div>
      </div>
    </section>
  );
}

interface HowItWorksSectionProps {
  className?: string;
  classNames?: SlotsToClasses<"base" | "container">;
  onStartNowPress?: () => void;
}

const STEPS = [
  {
    title: <>Describe <br />your project</>,
    description:
      "Choose a service. If you want, include a few details (size, timeline, budget) to get more accurate quotes.",
    icon: <ListOutlineIcon />,
  },
  {
    title: <>Get matched <br />with local pros</>,
    description:
      "We connect you with nearby professionals who fit your request. You can review profiles, services, and ratings before you decide who to contact.",
    icon: <PeopleIcon />,
  },
  {
    title: <>Compare & hire <br />with confidence</>,
    description:
      "Receive quotes, ask questions, and compare options. Pick the best pro for your project — there’s no obligation to hire.",
    icon: <GuaranteedIcon />,
  },
];